__turbopack_context__.v({
  "card": "MainPage-module-scss-module__kypIfW__card",
  "cardDiscount": "MainPage-module-scss-module__kypIfW__cardDiscount",
  "cardImage": "MainPage-module-scss-module__kypIfW__cardImage",
  "cardImageWrap": "MainPage-module-scss-module__kypIfW__cardImageWrap",
  "cardInfo": "MainPage-module-scss-module__kypIfW__cardInfo",
  "cardName": "MainPage-module-scss-module__kypIfW__cardName",
  "cardOriginalPrice": "MainPage-module-scss-module__kypIfW__cardOriginalPrice",
  "cardPrice": "MainPage-module-scss-module__kypIfW__cardPrice",
  "cardPriceRow": "MainPage-module-scss-module__kypIfW__cardPriceRow",
  "categoryGrid": "MainPage-module-scss-module__kypIfW__categoryGrid",
  "categorySections": "MainPage-module-scss-module__kypIfW__categorySections",
  "colorBar": "MainPage-module-scss-module__kypIfW__colorBar",
  "colorBars": "MainPage-module-scss-module__kypIfW__colorBars",
  "defaultImg": "MainPage-module-scss-module__kypIfW__defaultImg",
  "hero": "MainPage-module-scss-module__kypIfW__hero",
  "heroImgWrap": "MainPage-module-scss-module__kypIfW__heroImgWrap",
  "heroMosaic": "MainPage-module-scss-module__kypIfW__heroMosaic",
  "heroMosaicMain": "MainPage-module-scss-module__kypIfW__heroMosaicMain",
  "heroMosaicSide": "MainPage-module-scss-module__kypIfW__heroMosaicSide",
  "heroPlaceholder": "MainPage-module-scss-module__kypIfW__heroPlaceholder",
  "marquee": "MainPage-module-scss-module__kypIfW__marquee",
  "marqueeTrack": "MainPage-module-scss-module__kypIfW__marqueeTrack",
  "section": "MainPage-module-scss-module__kypIfW__section",
  "sectionTitle": "MainPage-module-scss-module__kypIfW__sectionTitle",
  "sectionTitleArrow": "MainPage-module-scss-module__kypIfW__sectionTitleArrow",
  "sectionTitleLink": "MainPage-module-scss-module__kypIfW__sectionTitleLink",
});
